import { GridCellProps } from '@progress/kendo-react-grid';
import { useCallback, useContext } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import { EditCellContext } from 'src/contexts/EditCellContext';
import { informationIcon } from 'src/utils/icons';

const DepartmentCell = (props: GridCellProps) => {
  const [cellClick] = useContext(EditCellContext);
  const { dataItem, field = '' } = props;

  const handleClick = useCallback(
    (e: any) => {
      e.stopPropagation();
      cellClick?.({ data: dataItem[field], type: field });
    },
    [cellClick, dataItem, field]
  );

  return (
    <GridCellBase {...props} rowSelectionEnabled disableToolTip>
      {dataItem.isNewGlCode ? (
        <span />
      ) : (
        <div className="flex justify-center items-center cursor-pointer">
          <div onClick={handleClick}>{informationIcon}</div>
        </div>
      )}
    </GridCellBase>
  );
};

export default DepartmentCell;
